var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('smart-table-table',{attrs:{"config":_vm.smartTableConfig,"state":_vm.smartTableState,"rows":_vm.$departments,"stickyHeader":true,"defaultFilterSpecification":'contains',"smaller":"","resizable":"","bordered":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }